import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./msalInstance";

// Renderizza l'app solo dopo l'inizializzazione di MSAL
// initialize() è richiesto da MSAL v4 per garantire che handleRedirectPromise()
// venga processato prima che qualsiasi componente tenti di usare l'istanza.
const root = ReactDOM.createRoot(document.getElementById("root"));
msalInstance.initialize().then(() => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});
